import './Metadata.css';
import { Component } from 'react';
import { Flow } from 'flow-react';
import { observer } from "mobx-react"

const Metadata = observer(
  class Metadata extends Component {
    state={
			ownermail:''
		}
		
		componentDidMount() {
			let ownerid = this.props.article.getMetadata().get('owner');
			this.props.flow.getUserById(ownerid).then(res=>this.setState({ownermail:res.email}));
		}
		

		render() {
			return  (
				<div className="articlemetadatacont">
					<div className="metadatarow">
						<div className="metalabel">Subheadline: </div>
						<div className="metavalue">{this.props.article.getMetadata().get('kicker')}</div>
					</div>
					<div className="metadatarow">
						<div className="metalabel">Owner: </div>
						<div className="metavalue">{this.state.ownermail}</div>
					</div>
					<div className="metadatarow">
						<div className="metalabel">Publishstatus: </div>
						<div className="metavalue">{this.props.article.getMetadata().get('publishstatus')}</div>
					</div>
					<div className="metadatarow">
						<div className="metalabel">Created: </div>
						<div className="metavalue">{this.props.article.getMetadata().get('created')}</div>
					</div>
				</div>
			);
		}
		
		
  }
)


export default Flow.injectFlow(Metadata);